import type { FC } from 'react'
import { NavbarContent } from './navbar-content'

export const DesktopNavbar: FC = () => {
    return <NavbarContent className="navbar-bg" />
}
